<div class="flex flex-row items-center gap-4">

  <button class="primary-btn my-4" (click)="addNewSocialAIPlan()">Add New Publio Plan</button>
  <button mat-mini-fab aria-label="view columns button" [matMenuTriggerFor]="menu">
    <mat-icon>view_column</mat-icon>
  </button>
  <mat-menu #menu="matMenu">
    <mat-checkbox *ngFor="let column of originalColumns" (change)="toggleColumnVisibility($event, column)"
      [checked]="displayedColumns.includes(column)" (click)="$event.stopPropagation()">
      {{ column }}
    </mat-checkbox>
  </mat-menu>
  <button mat-mini-fab aria-label="view columns button" (click)="showFilters=!showFilters">
    <mat-icon>filter_list</mat-icon>
  </button>
</div>


<!-- Filters -->

<div class="flex flex-row gap-4" *ngIf="showFilters">

  <mat-form-field appearance="fill">
    <mat-label>Name</mat-label>
    <input matInput [(ngModel)]="conditions.Name" name="Name">
    <mat-icon matPrefix>label</mat-icon>
  </mat-form-field>

  <mat-form-field class="example-form-field">
    <mat-label>Start Date - End Date</mat-label>
    <mat-datepicker-toggle matIconPrefix [for]="rangePicker"></mat-datepicker-toggle>
    <mat-date-range-input [rangePicker]="rangePicker">
      <input matStartDate [(ngModel)]="conditions.start_date" name="start_date" />
    </mat-date-range-input>
    <mat-date-range-picker #rangePicker>
      <mat-date-range-picker-actions>
        <button mat-button matDateRangePickerCancel>Cancel</button>
        <button mat-raised-button matDateRangePickerApply>Apply</button>
      </mat-date-range-picker-actions>
    </mat-date-range-picker>
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>Description</mat-label>
    <input matInput [(ngModel)]="conditions.Description" name="Description">
    <mat-icon matPrefix>description</mat-icon>
  </mat-form-field>


  <button mat-raised-button class="my-2 " (click)="applyConditions()">Apply</button>

  <button mat-raised-button class="my-2 !bg-red-500 !text-white" (click)="clearConditions()">Clear</button>
</div>

<!-- Table -->

<mat-table [dataSource]="dataSource" matSort class="!w-full !inline-table table-alternate">

  <!-- ID Column -->
  <ng-container matColumnDef="ID">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>ID</th>
    <td mat-cell *matCellDef="let element">
      {{ element.ID }}
    </td>
  </ng-container>

  <!-- Name Column -->
  <ng-container matColumnDef="Name">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
    <td mat-cell *matCellDef="let element">
      <div class="hover:text-blue-800 hover:underline cursor-pointer" (click)="editSocialAIPlan(element)">
        {{ element.Name }}
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="start_date">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Start Date</th>
    <td mat-cell *matCellDef="let element">{{ element.start_date | date:'dd/MM/yyyy' }}</td>

  </ng-container>

  <ng-container matColumnDef="PricingPlan">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Pricing Plan</th>
    <td mat-cell *matCellDef="let element">{{ element.planName }}</td>
  </ng-container>

  <ng-container matColumnDef="Description">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Description</th>
    <td mat-cell *matCellDef="let element">{{ element.Description }}</td>
  </ng-container>

  <ng-container matColumnDef="monthyear">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>monthyear</th>
    <td mat-cell *matCellDef="let element">{{ element.monthyear }}</td>
  </ng-container>

  <ng-container matColumnDef="price">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>price</th>
    <td mat-cell *matCellDef="let element">{{ element.price }}</td>
  </ng-container>

  <ng-container matColumnDef="discount">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>discount</th>
    <td mat-cell *matCellDef="let element">{{ element.discount }}</td>
  </ng-container>

  <ng-container matColumnDef="finalprice">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>finalprice</th>
    <td mat-cell *matCellDef="let element">{{ element.finalprice }}</td>
  </ng-container>

  <ng-container matColumnDef="updated_at">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>updated_at</th>
    <td mat-cell *matCellDef="let element">{{ element.updated_at | date:'dd/MM/yyyy' }}</td>
  </ng-container>

  <ng-container matColumnDef="delete">
    <th mat-header-cell *matHeaderCellDef>Delete</th>
    <td mat-cell *matCellDef="let element">
      <button mat-icon-button (click)="$event.stopPropagation();openDeleteSocialAIPlan(element)"
        class="!bg-red-500 !text-white">
        <mat-icon>delete</mat-icon>
      </button>
    </td>
  </ng-container>

  <!-- Header and Row Definitions -->
  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

</mat-table>

<mat-paginator [length]="totalItems" [pageSize]="12" showFirstLastButtons>
</mat-paginator>

<ng-template #publisherCommercialModelFormTmpl>
  <app-commercial-plan-form [formData]="selectedSocialAIPlan" (onSubmitClbk)="onSubmitSocialAIPlanClbk()"
    [companyID]="companyID"></app-commercial-plan-form>
</ng-template>

<ng-template #confirmDeleteTmpl>
  <div class="flex flex-col gap-4">
    <p>Are you sure you want to delete <b>{{ selectedSocialAIPlan.Name }}</b>?</p>
    <div class="flex flex-row items-center justify-center gap-2">
      <button mat-button (click)="deleteSocialAIPlan()">Confirm</button>
      <button mat-button (click)="dialog.closeAll();">Cancel</button>
    </div>
  </div>

</ng-template>